/*                                     */
import type { NexusResult, NexusSignal } from "@otto-ec/global-resources/nexus";
import { asExport } from "@otto-ec/global-resources/core";
import { components, type OttoComponents } from "../../../common/component.js";
import type { NexusEvents } from "./event/event.nexus.js";
import type {
  ActivationOptions,
  SheetCloseOptions,
  SheetCreateOptions,
  SheetCreateProps,
} from "./apis/utils.js";
import type { ActivationAction } from "./event/event.index.js";
import type { ActivationReason } from "./stack/stack.index.js";

export * from "./event/event.index.js";
export * from "./stack/stack.index.js";

declare global {
  interface OttoComponentApi {
    /**
 *
 *
 */
    sheetV1: SheetAsync;
  }
}

export interface OcSheetV1CurrentState {
  /**
 *
 */
  instance: HTMLOcSheetV1Element | null;
  /**
 *
 */
  id: string | null;
  /**
 *
 */
  isActive: boolean;
  /**
 *
 */
  action: ActivationAction | null;
  /**
 *
 */
  reason: ActivationReason | null;
  /**
 *
 *
 */
  length: number;
}

/**
 *
 */
export interface SheetAsync {
  /**
 *
 *
 *
 *
 *
 *
 *
 */
  current: NexusSignal<OcSheetV1CurrentState>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  open(sheetID: string, options?: ActivationOptions): NexusResult<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 */
  close(options?: SheetCloseOptions): NexusResult<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  back(options?: ActivationOptions): NexusResult<boolean>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  create(props?: SheetCreateProps, options?: SheetCreateOptions): NexusResult<HTMLOcSheetV1Element>;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  events: NexusEvents;

  /*              */
  getOpenSheet: () => NexusResult<HTMLOcSheetV1Element | null>;
  /*              */
  getContent: () => NexusResult<HTMLElement | null>;
  /*              */
  getHeader: () => NexusResult<HTMLElement | null>;
  /*              */
  getActions: () => NexusResult<HTMLElement | null>;
}

/**
 *
 */
export type SheetV1 = OttoComponents["sheetV1"];

/*                                                  */
export const sheet: SheetV1 = asExport(components, "sheetV1");

/*                                                           */
export const current: SheetV1["current"] = asExport(sheet, "current");

/*                                                */
export const open: SheetV1["open"] = asExport(sheet, "open");

/*                                                 */
export const close: SheetV1["close"] = asExport(sheet, "close");

/*                                                */
export const back: SheetV1["back"] = asExport(sheet, "back");

/*                                                  */
export const create: SheetV1["create"] = asExport(sheet, "create");

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const events: SheetV1["events"] = asExport(sheet, "events");

/*                                                                    */
export const getOpenSheet: SheetV1["getOpenSheet"] = asExport(sheet, "getOpenSheet");
/*                                                                 */
export const getHeader: SheetV1["getHeader"] = asExport(sheet, "getHeader");
/*                                                                  */
export const getContent: SheetV1["getContent"] = asExport(sheet, "getContent");
/*                                                                  */
export const getActions: SheetV1["getActions"] = asExport(sheet, "getActions");
